module.exports = __webpack_public_path__ + "static/media/logOut.3d8270a2.svg";